import { Link } from "react-router-dom";
import { isValidArray } from "../Common/common";
import { useCategoryLink } from "../../Context/hook/useCategoryLink";

export const SubCategoryMenu = ({ crow, subCatList }) => {
  const getCategoryLink = useCategoryLink();
  return (
    <div key={crow.categoryName} className="catg-menu-inner">
      <Link to={getCategoryLink(crow.categoryId, crow.url ?? crow.categoryUrl)} className="d-none d-lg-block">
        <h6>
          {crow.categoryName}
          <i className="fa-solid fa-chevron-right" />
        </h6>
      </Link>
      <a
        className="d-block d-lg-none"
        data-bs-toggle="collapse"
        href={"#" + crow.categoryId.replace(/ /g, "_")}
        role="button"
        aria-expanded="false"
        aria-controls={crow.categoryId.replace(/ /g, "_")}
      >
        <h6>
          {crow.categoryName}
          <i className="fa-solid fa-chevron-right" />
        </h6>
      </a>
      <div className="collapse thrid-collapse" id={crow.categoryId.replace(/ /g, "_")}>
        <p
          className="mob-categ-back back-subcategories"
          data-bs-toggle="collapse"
          href={"#" + crow.categoryId.replace(/ /g, "_")}
        >
          <i className="fa-solid fa-arrow-left-long" />
          Back to Categories
        </p>
        <div className="inner-third-level">
          <ul>
            {isValidArray(subCatList) &&
              subCatList.map((subrow, index) => (
                <li key={`${subrow.categoryId ?? subrow.categoryName}-${index}`}>
                  <Link to={getCategoryLink(subrow.categoryId, subrow.url ?? subrow.categoryUrl)}>
                    {subrow.categoryName}{" "}
                  </Link>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
